import { Button } from '../ui/button';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader,
  DialogTitle, DialogFooter,
} from '../ui/dialog';

export function PriceChangeWarningDialog({
  open, onOpenChange, priceChanges,
  handleConfirmPriceChange, handleCancel,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-[#262626] max-w-md">
        <DialogHeader>
          <DialogTitle className="text-yellow-400">Price Changes Detected</DialogTitle>
          <DialogDescription>
            Some artist prices have changed since you added items to your cart:
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          {priceChanges.map((change) => (
            <div
              key={change.artist_name}
              className="flex items-center justify-between p-3 bg-yellow-500/5 border border-yellow-500/20 rounded-lg"
              data-testid={`price-change-${change.artist_name}`}
            >
              <span className="font-medium text-sm">{change.artist_name}</span>
              <div className="text-right text-sm">
                <span className="line-through text-[#666]">${change.old_price.toFixed(2)}</span>
                <span className="ml-2 text-yellow-400 font-mono">${change.new_price.toFixed(2)}</span>
              </div>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel} className="border-[#262626]" data-testid="cancel-price-change">
            Cancel
          </Button>
          <Button onClick={handleConfirmPriceChange} className="btn-primary" data-testid="confirm-price-change">
            Continue with New Prices
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
